import axios from 'axios'
import store from '@/store'
import { getAuthClient } from '@/plugins/auth-client'

declare const baseApiUrl: string
const resolvedBaseApiUrl =
  typeof baseApiUrl === 'undefined' ? '/api' : baseApiUrl

const httpClient = axios.create({
  baseURL: resolvedBaseApiUrl,
  validateStatus: (status) => status >= 200 && status < 300
})

let refreshRequest: Promise<unknown> | null = null

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const requestUrl = error?.config?.url?.replace(/^\//, '')

    if (requestUrl === 'event-logs') {
      return Promise.reject(error)
    }

    if (error?.response?.status === 401) {
      const auth = getAuthClient()
      if (requestUrl === 'auth/refresh') {
        const redirectPath =
          document.location.pathname === '/auth/verify-email'
            ? document.location.pathname + document.location.search
            : '/'
        auth?.logout({
          makeRequest: false,
          redirect: {
            name: 'VerifyEmailAddress',
            query: { redirect_path: redirectPath }
          }
        })
        store.dispatch('data/clear')
      } else if (auth?.token() && !error.config._authRetry) {
        // 更新完了を待って元のリクエストを一度だけ再試行する。
        // 待たずに401を返すと、vue-authが更新と並行してログアウトしてしまう。
        if (!refreshRequest) {
          refreshRequest = auth.refresh().finally(() => {
            refreshRequest = null
          })
        }
        try {
          await refreshRequest
        } catch {
          return Promise.reject(error)
        }
        return httpClient.request({ ...error.config, _authRetry: true })
      }
    }

    if (error?.response?.status === 501) {
      const location = new URL(window.location.href)

      if (process.env.MIX_APP_ENV === 'production') {
        window.location.href =
          location.protocol + '//app.grtx.jp' + location.pathname
      } else if (process.env.MIX_APP_ENV === 'staging') {
        window.location.href =
          location.protocol + '//stg-app.grtx.jp' + location.pathname
      }
    }

    if (process.env.NODE_ENV !== 'production') console.log(error)
    return Promise.reject(error)
  }
)

export default httpClient
